import { combineReducers } from 'redux';
import {
  TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_SET_TABLE,
  TABLE_MANAGEMENT_MAP_SET_TABLES,
  TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES,
  TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT,
} from 'actions/tableManagement/constants';
import _isEqual from 'lodash/isEqual';

import createReducer from 'utils/createReducer';

const disableSaveLayoutButton = createReducer(true, {
  [TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT]: (draft, { payload }) =>
    _isEqual(payload.tables, payload.originalTables),
});

const isSubmittingForm = createReducer(false, {});

const originalTables = createReducer([], {
  [TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES]: (draft, { payload }) =>
    payload.originalTables,
});

const outlets = createReducer([], {});
const setting = createReducer({}, {});

const showAddTableModal = createReducer(false, {
  [TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE]: () => true,
  [TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE]: () => false,
});

const showDeleteModal = createReducer(false, {
  [TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL]: () => true,
  [TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL]: () => false,
});

const showEditTableModal = createReducer(false, {
  [TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL]: () => true,
  [TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL]: () => false,
});

const table = createReducer(null, {
  [TABLE_MANAGEMENT_MAP_SET_TABLE]: (draft, { payload }) => payload.table,
});

const tables = createReducer([], {
  [TABLE_MANAGEMENT_MAP_SET_TABLES]: (draft, { payload }) => payload.tables,
});

export default combineReducers({
  disableSaveLayoutButton,
  isSubmittingForm,
  originalTables,
  outlets,
  setting,
  showAddTableModal,
  showDeleteModal,
  showEditTableModal,
  table,
  tables,
});
